import { render, staticRenderFns } from "./product-finish-groups.vue?vue&type=template&id=84c35998&scoped=true&"
import script from "./product-finish-groups.vue?vue&type=script&lang=js&"
export * from "./product-finish-groups.vue?vue&type=script&lang=js&"
import style0 from "./product-finish-groups.vue?vue&type=style&index=0&id=84c35998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c35998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c35998')) {
      api.createRecord('84c35998', component.options)
    } else {
      api.reload('84c35998', component.options)
    }
    module.hot.accept("./product-finish-groups.vue?vue&type=template&id=84c35998&scoped=true&", function () {
      api.rerender('84c35998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/product-finishes-slider/components/product-finish-groups.vue"
export default component.exports